import React from "react";
import { useTranslation } from "react-i18next";

export default function RecruitmentModal({ onClose }) {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center px-4 text-primary">
      <div className="bg-white rounded-2xl p-6 max-w-3xl w-full shadow-lg text-center">
        <h2 className="text-xl font-bold mb-2">
          {t("recruitmentModal.title")}
        </h2>
        <p className="mb-4 text-sm">{t("recruitmentModal.description")}</p>
        <p className="mb-4 text-sm font-medium">
          {t("recruitmentModal.callToAction")}
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-2">
          <a
            href="/become-provider"
            className="bg-primary text-white px-4 py-2 rounded-full hover:bg-primary-dark transition"
          >
            {t("recruitmentModal.button.becomeSupplier")}
          </a>
          <button
            onClick={onClose}
            className="bg-gray-200 text-gray-700 px-4 py-2 rounded-full hover:bg-gray-300 transition"
          >
            {t("recruitmentModal.button.continue")}
          </button>
        </div>
      </div>
    </div>
  );
}
